import axios from "axios";
// import { auth } from "../firebase/firebase.config";

import { API_BASE_URL } from "./config";

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosClient;
